'use client'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import {
  fixCartBeforeCheckout,
  razorpayPaymentCaptureOrder,
  razorpayPaymentCreateOrder
} from '@app/actions'
import CartProductCards from '@components/atoms/CartProductCards'
import { DateTimeChoose } from '@components/atoms/DeliveryDatePicker'
import GreenBarForMobile from '@components/atoms/GreenBarForMobile'
import PriceBox from '@components/atoms/PriceBox'
import CartSkeleton from '@components/atoms/skeleton/CartSkeleton'
import { userContext } from '@components/context/userContext'
import AddNewAddressContext from '@components/molecules/AddNewAddressContext'
import CouponSelector, {
  CouponSelectedProp,
  fetchCoupons
} from '@components/molecules/CouponSelector'
import EditAddressDialogue from '@components/molecules/EditAddressDialogie'
import { Button } from '@components/ui/button'
import { Dialog, DialogTrigger } from '@components/ui/dialog'
import { RadioGroup, RadioGroupItem } from '@components/ui/radio-group'
import { Separator } from '@components/ui/separator'
import { Skeleton } from '@components/ui/skeleton'
import { updateCartfn } from '@lib/CartServices'
import { sendGTMEvent } from '@next/third-parties/google'
import useCartStore, { CartItem } from '@store/CartStore'
import { ChevronDownIcon, ChevronRight } from 'lucide-react'
import { useSession } from 'next-auth/react'
import { useRouter, useSearchParams } from 'next/navigation'
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import useRazorpay from 'react-razorpay'

const FullCart = () => {
  const [RazorPay] = useRazorpay()
  const { data: session } = useSession()
  const [loading, setLoading] = useState(false)
  const user = useContext(userContext)
  const cartStore = useCartStore()
  const searchParams = useSearchParams()
  const router = useRouter()
  const [paymentScreen, setPaymentScreen] = useState(false)
  const [selectedAdressIndex, setSelectedAddressIndex] = useState(0)
  const addNewAddresTriggerRef = useRef<HTMLButtonElement>(null)
  const [couponSelected, setCouponSelected] = useState<CouponSelectedProp | undefined>(undefined)
  const [highestCoupon, setHighestCoupon] = useState<undefined | number>(undefined)

  const totalPrice = useMemo(() => {
    let price = 0
    cartStore?.cartItems.map((ele) => {
      const iteration = ele.price * ele.quantity * (1 + ele.discountPerc / 100)
      price += iteration
    })
    return Math.round(price)
  }, [cartStore?.cartItems])

  const totalDiscount = useMemo(() => {
    let price = 0
    cartStore?.cartItems.map((ele) => {
      const itemDiscount = ele.price * ele.quantity * (ele.discountPerc / 100)
      price += itemDiscount
    })

    return Math.round(price)
  }, [cartStore?.cartItems])

  // useEffect(() => {
  //   const calculateDeliveryCharges = async () => {
  //     setLoading(true)
  //     let tempPrice = 0
  //     if (cartStore && user.currentLocationCoords) {
  //       for (const item of cartStore.cartItems) {
  //         // const vendorDets = await nearestVendorDetails({
  //         //   coords: {
  //         //     latitude: user.currentLocationCoords!.latitude,
  //         //     longitude: user.currentLocationCoords!.longitude
  //         //   },
  //         //   vendors: item.vendorIds
  //         // })

  //         const time = new Date().getHours()
  //         const deliveryChargePerKm =
  //           time > 19 || time < 7
  //             ? item.transportationCostPerKm.night
  //             : item.transportationCostPerKm.day

  //         // const deliveryPrice =
  //         //   (vendorDets[0].distanceMatrix.elements[0].distance.value / 1000) * deliveryChargePerKm
  //         const deliveryPrice = 0

  //         // console.log({ deliveryPrice }, { deliveryChargePerKm }, { vendorDets })
  //         cartStore.updateCart({
  //           method: 'setNearestVendor',
  //           deliveryPrice: String(deliveryPrice),
  //           productId: item.productId,
  //           distance: '0',
  //           nearestVendorId: item.vendorIds[0].id
  //         })

  //         if (session) {
  //           updateCart({
  //             cartId: String(item.cartId!),
  //             productId: item.productId,
  //             userId: session.user.userId,
  //             userCustomizationData: JSON.stringify(item.userCustomizationData),
  //             deliveryprice: 0,
  //             distance: String(0),
  //             // distance: String(vendorDets[0].distanceMatrix.elements[0].distance.value),
  //             nearestVendor: item.vendorIds[0].id
  //           })
  //         }

  //         tempPrice += deliveryPrice
  //       }
  //     }
  //     setDeliveryPrice(Math.ceil(tempPrice))
  //     setLoading(false)
  //   }
  //   calculateDeliveryCharges()
  // }, [nearestVendorDetails, session, user.currentLocationCoords])

  const totalAmoutBeforeCoupons = useMemo(() => {
    return totalPrice - totalDiscount
  }, [totalDiscount, totalPrice])

  const totalAmount = useMemo(() => {
    if (couponSelected) {
      return totalPrice - totalDiscount - couponSelected.discountAmount
    }
    return totalPrice - totalDiscount
    // if (deliveryPrice) return totalPrice - totalDiscount + deliveryPrice
    // else return undefined
  }, [couponSelected, totalDiscount, totalPrice])

  useEffect(() => {
    if (!session?.user) {
      const getCouponData = async () => {
        if (totalAmount) {
          const coupons = await fetchCoupons(totalAmount)
          if (coupons.coupons.length > 0) {
            setHighestCoupon(coupons.coupons[0].discount)
          }
        }
      }
      getCouponData()
    }
  }, [session?.user, totalAmount])

  const handleLogin = useCallback(() => {
    router.push(`/signin?target=shopping-cart/cart`)
  }, [router])

  const handleCheckout = async () => {
    const isTest = searchParams.get('test')
    if (user.addresses.length === 0) {
      return
    }

    try {
      console.log('cart updated')
      if (session && cartStore) {
        await fixCartBeforeCheckout(
          session.user.userId,
          cartStore!.selectedAddressId!!,
          cartStore.deliverySlot!!,
          cartStore.deliveryDate!!,
          couponSelected?.code
        )
        setPaymentScreen(true)
        const order = await razorpayPaymentCreateOrder({
          amountInRupees: isTest ? 1 : totalAmount,
          userId: session.user.userId
        })

        const rzp1 = new RazorPay({
          key: process.env.RAZOR_PAY_LIVE_KEY!,
          amount: isTest ? '1' : totalAmount.toString(), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: 'INR',
          name: 'Eventshoppe',
          description: 'Order#: ' + order.id,
          image: 'https://eventshoppe.in/icon-384x384.png',
          order_id: order.id, //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
          handler: async function (response) {
            await razorpayPaymentCaptureOrder({
              orderId: response.razorpay_order_id,
              paymentId: response.razorpay_payment_id,
              razorpaySignature: response.razorpay_signature,
              userId: session.user.userId
            }).then(() => {
              if (!isTest) {
                sendGTMEvent({
                  event: 'purchase',
                  products: cartStore.cartItems.map((item) => ({
                    content_id: item.productId,
                    content_name: item.name,
                    value: item.price,
                    quantity: item.quantity,
                    content_category: '',
                    currency: 'INR'
                  })),
                  contents: []
                })
              }
              setTimeout(() => {
                router.push('/orders/status/' + response.razorpay_order_id)
              }, 2000)
            })
          },
          prefill: {
            name: session.user.firstName + ' ' + session.user.lastName,
            email: session.user.emailId,
            contact: session.user.phoneNumber
          },
          theme: {
            color: '#ee4262'
          }
        })
        rzp1.on('payment.failed', function () {
          setPaymentScreen(false)
        })
        rzp1.open()
        // .then((link) => {
        //   sendGTMEvent({
        //     event: 'conversion_event_purchase',
        //     value: {
        //       // event_callback: callback,
        //       event_timeout: 2000
        //     }
        //   })
        //   router.push(link)

        // })
      } else {
        console.log('---------------------------------')
      }
    } catch (error) {
      console.log(error)
    }
    // updating coupon code to first product
  }

  const handleUpdateQty = (item: CartItem, qty: number) => {
    const product = cartStore?.cartItems.find((ele) => ele.productId === item.productId)
    const date = cartStore?.deliveryDate
    if (product) {
      if (session?.user) {
        updateCartfn({
          addressId: product.addressId,
          deliverydate: date!!,
          deliveryprice: Number(product.deliveryPrice),
          discountedprice: String(product.discountPerc),
          distance: product.distance,
          nearestVendor: product.nearestVendorId,
          price: product.price,
          productId: product.productId,
          productname: product.name,
          quantity: qty,
          timeslot: cartStore!.deliverySlot!,
          transportationcostperkm: JSON.stringify(product.transportationCostPerKm),
          userCustomizationData: JSON.stringify(product.userCustomizationData),
          userId: session!.user.userId,
          vendorids: JSON.stringify(product.vendorIds)
        }).then(() => {
          cartStore?.updateCart({ method: 'quantity', item: product, qty: qty })
        })
      } else {
        cartStore?.updateCart({ method: 'quantity', item: product, qty: qty })
      }
    }
  }

  return (
    <div className="min-h-[90vh]">
      {cartStore ? (
        <>
          <div className="md:hidden pt-2">
            <Dialog>
              {/*-------------------- Phone address -----------------------*/}
              {/* This will render in m screens only */}
              {session ? (
                user.addresses.length > 0 ? (
                  <>
                    <Collapsible className=" bg-primary-50 p-2 px-4">
                      <div>
                        <div className=" flex justify-between py-2">
                          <CollapsibleTrigger className=" ">
                            {/* <DialogTrigger> */}
                            <div className="flex items-center gap-2 flex-grow w-full">
                              <span className="label_medium">Delivering to</span>
                              <span className="heading_small flex items-center gap-1">
                                {' '}
                                {user.addresses[selectedAdressIndex].name}
                                <ChevronDownIcon />
                              </span>
                            </div>
                            <div className=" text-left">
                              {user.addresses[selectedAdressIndex].address.length > 35
                                ? `${user.addresses[selectedAdressIndex].address.slice(0, 35)}...`
                                : user.addresses[selectedAdressIndex].address}
                            </div>
                            {/* </DialogTrigger> */}
                          </CollapsibleTrigger>
                          <EditAddressDialogue
                            address={user.addresses[selectedAdressIndex].address}
                            latitude={user.addresses[selectedAdressIndex].latitude}
                            longitude={user.addresses[selectedAdressIndex].longitude}
                            makeDefaultAddress={
                              user.addresses[selectedAdressIndex].makedefaultaddress
                            }
                            mobilenumber={user.addresses[selectedAdressIndex].mobilenumber}
                            name={user.addresses[selectedAdressIndex].name}
                            locality={user.addresses[selectedAdressIndex].locality}
                            addressId={user.addresses[selectedAdressIndex].addressid}
                            key={selectedAdressIndex}
                          />
                        </div>
                        <CollapsibleContent>
                          {user.addresses.map((adress, ind) => (
                            <div
                              key={ind}
                              className="label_small"
                              onClick={() => {
                                user.setLocationCoords({
                                  displayAdress: adress.address,
                                  latitude: Number(adress.latitude),
                                  longitude: Number(adress.longitude),
                                  isInsideTheCity: true
                                })
                                setSelectedAddressIndex(ind)
                                cartStore.updateCart({
                                  method: 'setAddressId',
                                  addressId: adress.addressid
                                })
                              }}
                            >
                              <CollapsibleTrigger className=" w-full text-left pb-1">
                                <div className=" flex items-center font-bold">{adress.name}</div>
                                <div className="pl-2">
                                  <div>{adress.address}</div>
                                  <div>
                                    <div>Mobile Number:</div>
                                    <div>{adress.mobilenumber}</div>
                                    {ind < user.addresses.length - 1 && (
                                      <Separator className=" bg-gray-400" />
                                    )}
                                  </div>
                                  {adress.locality ? (
                                    <div>Landmark: {adress.locality}</div>
                                  ) : undefined}
                                </div>
                                <AddNewAddressContext
                                  prefill={user.addresses.length == 0}
                                  onSubmited={() => {
                                    setSelectedAddressIndex(ind + 1)
                                  }}
                                />
                              </CollapsibleTrigger>
                            </div>
                          ))}
                          <div className="bg-primary-50 flex flex-col gap-2 ">
                            <Separator className="  bg-gray-300" />
                            <DialogTrigger className="flex justify-between w-full">
                              <Button
                                variant={'outline'}
                                className=" label_medium   font-extrabold w-full border-primary-500"
                              >
                                Add Delivery address
                              </Button>
                            </DialogTrigger>
                          </div>
                        </CollapsibleContent>
                      </div>
                    </Collapsible>
                  </>
                ) : (
                  <div className="bg-primary-50 p-4 ">
                    <DialogTrigger className="flex justify-between w-full">
                      <div className=" label_medium text-neutral-700">Delivery Adress</div>
                      <div className=" label_medium text-primary-500  font-extrabold">
                        Add Delivery address
                      </div>
                    </DialogTrigger>
                  </div>
                )
              ) : undefined}

              <AddNewAddressContext prefill={user.addresses.length == 0} />
            </Dialog>

            {/*---------------------- Phone date time choose---------------- */}
            {/* I am using a different component for phone date time choose */}
            <div className=" label_medium font-bold flex flex-col gap-2 w-full px-4 pt-2">
              Delivery date & time
              <div className=" border-primary-500 border rounded-sm">
                <DateTimeChoose />
              </div>
              <div className=" text-neutral-700 label_small pb-3">
                To serve you better, let us know the{' '}
                <span className=" text-primary-500">event time & date</span> to schedule delivery.
              </div>
            </div>
          </div>

          {/* fixed panel for mobile */}
          {/* This pannel is fixed on the bottom where we display the price and 
          button to checkout or add a new address incase the addresses are 
          zero */}

          <div className="fixed bottom-0 bg-white w-full shadow-[0_0px_20px_-15px_rgba(0,0,0,0.5)] flex flex-col md:hidden  ">
            {highestCoupon ? (
              <GreenBarForMobile>
                Login to get additional ₹{highestCoupon} discount
              </GreenBarForMobile>
            ) : undefined}
            <div className="flex justify-between pl-6 p-2 pb-6">
              {loading ? (
                // loading screen
                <div className=" flex justify-between w-full">
                  <div className=" flex flex-col gap-2">
                    <Skeleton className="h-3 w-16" />
                    <Skeleton className="h-3 w-16" />
                  </div>
                  <Skeleton className="h-10 w-2/6" />
                </div>
              ) : cartStore.cartItems.length > 0 ? (
                // only rendere when the cart is not empty
                <>
                  <div>
                    <div className=" line-through mobile_thin_small md:label_medium text-neutral-600">
                      ₹{totalAmount ? (totalAmount + totalDiscount).toLocaleString() : '...'}
                    </div>
                    <div className=" mobile_semibold md:heading_small font-semibold">
                      {totalAmount ? `₹${totalAmount.toLocaleString()}` : '...'}
                    </div>
                  </div>
                  <div className=" min-w-[60%]">
                    {session ? (
                      // when session is there, I am handling checkout or add adress
                      <>
                        {user.addresses.length > 0 ? (
                          <Button
                            className=" w-full text-white px-12 flex-1"
                            onClick={handleCheckout}
                          >
                            Place Order
                          </Button>
                        ) : (
                          // triggering add address btn
                          <Button
                            className=" w-full text-white px-12 flex-1"
                            onClick={() => addNewAddresTriggerRef.current?.click()}
                          >
                            Add address
                          </Button>
                        )}
                      </>
                    ) : (
                      // session is not there, so login btn
                      <Button
                        className=" w-full mobile_semibold text-white px-12 "
                        onClick={handleLogin}
                      >
                        Login
                      </Button>
                    )}
                  </div>
                </>
              ) : undefined}
            </div>
          </div>

          <Dialog>
            {cartStore?.cartItems.length && cartStore?.cartItems.length > 0 ? (
              <div className="w-full flex flex-col md:flex-row gap-2 px-4 pb-4 md:pb-8 md:px-0">
                <div className=" border w-full md:basis-3/5 rounded-sm md:mr-4">
                  {cartStore?.cartItems.map((item, ind) => (
                    <div key={ind}>
                      {/* this will render the products inside the cart 
                      with first image, name, price, user customizations. 
                      the user customizations cannot be modified, onqty update 
                      a callback is there */}
                      <CartProductCards
                        onQtyUpdate={(val) => {
                          // this will call the updateCart, and on updarte the
                          // the cart context gets updated
                          handleUpdateQty(item, val)
                        }}
                        {...item}
                      />
                      {ind !== cartStore.cartItems.length - 1 ? (
                        <div className=" border mx-3"></div>
                      ) : undefined}
                    </div>
                  ))}
                </div>

                {/* ---------------- m device buttons--------------------- */}
                <div className="w-full basis-2/5 flex flex-col gap-5 justify-between">
                  <div className=" label_medium justify-between items-center whitespace-nowrap pl-4 border border-neutral-200 rounded-sm hidden md:flex">
                    Your order will be fullfilled by
                    <div className=" flex items-center gap-2 justify-center p-2">
                      <DateTimeChoose />
                    </div>
                  </div>
                  {session ? (
                    <>
                      {user.addresses.length > 0 ? (
                        // checkout here
                        <Button
                          disabled={loading}
                          className="hidden md:flex text-white"
                          onClick={handleCheckout}
                        >
                          Checkout ({cartStore?.cartItems.length}&nbsp;item
                          {cartStore?.cartItems.length !== 1 ? 's' : ''})&nbsp;
                          <ChevronRight />
                        </Button>
                      ) : (
                        // add address trigger
                        <div className="hidden md:block">
                          <Button
                            className=" text-white w-full"
                            onClick={() => addNewAddresTriggerRef?.current?.click()}
                          >
                            Please add an address to continue <ChevronRight />
                          </Button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className=" text-left md:flex flex-col hidden border p-4 gap-4">
                      <div className=" label_medium">To Checkout, please login</div>
                      <Button className=" w-full text-white" onClick={handleLogin}>
                        Login
                      </Button>
                    </div>
                  )}
                  {/* m device price calculations */}
                  <div className="flex md:flex-col flex-col-reverse gap-2">
                    {cartStore?.cartItems.length && cartStore?.cartItems.length > 0 ? (
                      <>
                        {totalAmount && !loading ? (
                          <PriceBox
                            totalPriceHeading={`Total item price(${cartStore?.cartItems.length} Items)`}
                            totalPrice={totalPrice}
                            totalDiscountHeading="Discount"
                            totalDiscount={totalDiscount}
                            couponSelected={couponSelected}
                            totalAmount={totalAmount}
                          />
                        ) : (
                          <CartSkeleton />
                        )}
                      </>
                    ) : undefined}
                    {session && session.user ? (
                      <div className="border rounded-sm px-2">
                        <CouponSelector
                          amount={totalAmoutBeforeCoupons}
                          onSelectingCoupon={setCouponSelected}
                          couponApplied={couponSelected !== undefined}
                        />
                      </div>
                    ) : undefined}
                  </div>
                  {/*------------------ address pc ------------------*/}
                  {session ? (
                    <div className="hidden md:flex">
                      <>
                        {user.addresses.length > 0 ? (
                          <div className="w-full">
                            <div className=" title_large flex justify-between py-3">
                              <div>Delivery Adress</div>
                              <DialogTrigger>
                                <Button className=" text-primary-500 bg-primary-100 title_medium">
                                  Add new
                                </Button>
                              </DialogTrigger>
                            </div>
                            <RadioGroup
                              defaultValue={user.addresses[selectedAdressIndex].addressid}
                              className="w-full"
                            >
                              {user.addresses.map((adress, ind) => (
                                <div key={ind} className=" border p-4 rounded-sm w-full">
                                  <div className=" flex gap-2 items-center title_medium">
                                    <RadioGroupItem
                                      value={adress.addressid}
                                      onClick={() => {
                                        user.setLocationCoords({
                                          displayAdress: adress.address,
                                          latitude: Number(adress.latitude),
                                          longitude: Number(adress.longitude),
                                          isInsideTheCity: true
                                        })
                                        cartStore.updateCart({
                                          method: 'setAddressId',
                                          addressId: adress.addressid
                                        })
                                      }}
                                    />
                                    {adress.name}
                                  </div>
                                  <div className=" pl-6">
                                    <div className=" py-2">{adress.address}</div>
                                    <div className=" flex items-center">
                                      <div>Mobile Number:</div>
                                      <div className=" pl-2">{adress.mobilenumber}</div>
                                    </div>
                                  </div>

                                  <EditAddressDialogue
                                    address={adress.address}
                                    latitude={adress.latitude}
                                    longitude={adress.longitude}
                                    makeDefaultAddress={adress.makedefaultaddress}
                                    mobilenumber={adress.mobilenumber}
                                    name={adress.name}
                                    locality={adress.locality}
                                    addressId={adress.addressid}
                                    key={ind}
                                  />
                                </div>
                              ))}
                            </RadioGroup>
                          </div>
                        ) : (
                          <DialogTrigger className="w-full" ref={addNewAddresTriggerRef}>
                            {/* <div> */}
                            <Button className=" text-primary-500 bg-primary-100 title_medium w-full">
                              Add new address
                            </Button>
                            {/* </div> */}
                          </DialogTrigger>
                        )}
                      </>
                    </div>
                  ) : undefined}
                </div>
                <AddNewAddressContext prefill={user.addresses.length == 0} />
              </div>
            ) : (
              <div className=" w-full  rounded-sm text-center text-gray-700 flex flex-col gap-4 justify-center items-center">
                <div className="headline_large ">YOUR CART IS EMPTY</div>
                <div className=" text-gray-400">
                  <div className=" title_large">There is nothing in your cart.</div>
                  <div className=" title_large">Let's add some items</div>
                </div>
                <div>
                  <Button
                    className=" text-primary-500 border-primary-500"
                    onClick={() => {
                      router.push('/products/OC34/CAT63')
                    }}
                    variant={'outline'}
                  >
                    Start shopping
                  </Button>
                </div>
              </div>
            )}
          </Dialog>
        </>
      ) : (
        <div>Loading......</div>
      )}

      {paymentScreen ? (
        <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center w-screen h-screen bg-white/50">
          <div>
            <span className="relative flex size-12">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full size-12 bg-primary-500/80"></span>
            </span>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default FullCart
